import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lp2-notifications-list-page',
  template: '<lp2-notifications-list-iframe></lp2-notifications-list-iframe>',
  styleUrls: ['./notifications-list-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationsListPageComponent {}



// WEBPACK FOOTER //
// ./ts/app/notifications-list/notifications-list-page/notifications-list-page.component.ts